import React from "react";
import { useMessages } from "@lululemon/auth-common";
import { messages as modeMessages } from "../../../siginin-widget/constants";
import styles from "./mode-view.module.scss";
export var ModeView = function (_a) {
    var mode = _a.mode;
    var messages = useMessages().messages;
    if (!mode)
        return null;
    var _b = modeMessages[mode], title = _b.title, subtitle = _b.subtitle;
    return (<div className="mode-view-container">
      <h2 className={styles.oFormTitle} data-testid="login-modal-header-text">
        {messages[title]}
      </h2>
      <span className={styles.textBlock} data-testid="login-modal-sub-header-text">
        {messages[subtitle]}
      </span>
    </div>);
};
